/**
 * Fallback email opt-out acknowledgment. Canonical source is EmailOptOutConstants on the API.
 */
export const emailOptOutAcknowledgmentText =
  'Turning off optional emails does not relieve you of your responsibilities. You remain responsible for meeting deadlines and completing required activities. You can turn emails back on at any time.';
